<template>
  <div class="main-page">

    <!-- ===== 섹션 1: 메인 비주얼 (1.png) ===== -->
    <section class="sec sec-hero">
      <img :src="require('@/assets/1.png')" alt="메인 비주얼" class="hero-img" />
    </section>

    <!-- ===== 섹션 2: 선착순 7세대 ~1억원대부터 ===== -->
    <section class="sec sec-highlight">
      <div class="sec-inner highlight-inner">
        <p class="highlight-sub"><strong>선착순 파격 금융혜택</strong></p>
        <span class="highlight-big">7</span>
        <p class="highlight-sub"><strong>세대</strong></p>
        <div class="highlight-arrows">
          <svg class="highlight-arrow" v-for="n in 3" :key="n" :style="{ animationDelay: (n * 0.15) + 's' }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <polyline points="19 12 12 19 5 12"/>
          </svg>
        </div>
      </div>
    </section>

    <!-- ===== 3대 파격 혜택 ===== -->
    <section class="sec sec-benefit">
      <div class="sec-inner">
        <p class="benefit-big-text">다 해드립니다</p>
        <div class="benefit-divider"></div>

        <div class="stamp-area">
          <div class="stamp stamped" v-for="(item, idx) in benefits" :key="idx">
            <div class="stamp-inner">
              <span class="stamp-num">{{ String(idx + 1).padStart(2, '0') }}</span>
              <span class="stamp-label">BENEFIT</span>
              <div class="stamp-line"></div>
              <h3 class="stamp-title">{{ item.title }}</h3>
              <p class="stamp-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>

        <div class="benefit-tagline">
          <span class="benefit-tagline-text">실입주금 <strong>1억대</strong></span>
          <span class="benefit-tagline-mark">!</span>
        </div>

        <div class="benefit-seals">
          <div class="seal" v-for="(s, i) in seals" :key="i">
            <span class="seal-top">{{ s.top }}</span>
            <span class="seal-bottom">{{ s.bottom }}</span>
          </div>
        </div>

        <div class="benefit-video">
          <div class="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/Axe63LKENEo?si=ebwhhNvvAILy4alf"
              title="YouTube video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        </div>

      </div>
    </section>

    <!-- ===== 입지환경 ===== -->
    <section class="sec sec-location">
      <div class="sec-inner">
        <p class="sec-eyebrow">LOCATION</p>
        <h2 class="section-title">입지환경</h2>
      </div>
      <div class="location-caption-row">
        <p class="location-caption">
          <strong>장안동 맛의거리</strong> 중심에 위치하여<br/>편리한 생활환경
        </p>
        <div class="location-logo">
          <img :src="require('@/assets/logo/logo_symbol.png')" alt="로고 심볼" class="location-logo-symbol" />
          <img :src="require('@/assets/logo/logo_text.png')" alt="로고 텍스트" class="location-logo-text" />
        </div>
      </div>
      <img :src="require('@/assets/2.jpg')" alt="입지환경" class="location-img" />

      <div class="location-grid">
        <div class="location-card" v-for="(item, idx) in locationInfos" :key="idx">
          <div class="location-card-head">
            <span class="location-card-num">{{ idx + 1 }}</span>
            <h3 class="location-card-title">{{ item.title }}</h3>
          </div>
          <p class="location-card-desc" v-html="item.desc"></p>
        </div>
      </div>
    </section>

    <!-- ===== 무상옵션 패키지 ===== -->
    <section class="sec sec-option">
      <div class="sec-inner">
        <p class="sec-eyebrow">FREE OPTION</p>
        <h2 class="section-title">장안센트럴만의<br/>무상옵션 패키지</h2>

        <div class="option-grid">
          <div class="option-item" v-for="(item, idx) in freeOptions" :key="idx">
            <div class="option-icon-wrap">
              <svg v-if="item.key==='oven'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><circle cx="7" cy="7" r="1"/><circle cx="11" cy="7" r="1"/><rect x="6" y="13" width="12" height="6" rx="1"/></svg>
              <svg v-else-if="item.key==='cooktop'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="20" height="16" rx="2"/><circle cx="8" cy="10" r="3"/><circle cx="16" cy="10" r="2.5"/><circle cx="8" cy="10" r="1"/><circle cx="16" cy="10" r="1"/></svg>
              <svg v-else-if="item.key==='fridge'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="4" y1="10" x2="20" y2="10"/><line x1="17" y1="5" x2="17" y2="8"/><line x1="17" y1="13" x2="17" y2="17"/></svg>
              <svg v-else-if="item.key==='aircon'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="20" height="10" rx="2"/><path d="M6 14v2c0 2 2 4 6 4s6-2 6-4v-2"/><line x1="6" y1="11" x2="18" y2="11"/></svg>
              <svg v-else-if="item.key==='clean'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2v6"/><path d="M8.5 4.5l1 5"/><path d="M15.5 4.5l-1 5"/><circle cx="12" cy="14" r="6"/><path d="M9 13.5c0-1.5 1.5-2.5 3-2.5s3 1 3 2.5"/></svg>
              <svg v-else-if="item.key==='stone'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="6" width="20" height="4" rx="1"/><path d="M4 10v8h16v-8"/><line x1="8" y1="6" x2="8" y2="10"/><line x1="16" y1="6" x2="16" y2="10"/></svg>
            </div>
            <span class="option-name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 프리미엄 5 ===== -->
    <section class="sec sec-premium">
      <div class="sec-inner">
        <p class="sec-eyebrow">PREMIUM</p>
        <h2 class="section-title">프리미엄 5</h2>

        <div class="premium-list">
          <div class="premium-card" v-for="(item, idx) in premiums" :key="idx">
            <div class="premium-head">
              <span class="premium-num">{{ idx + 1 }}</span>
              <h3 class="premium-card-title">{{ item.title }}</h3>
            </div>
            <p class="premium-card-desc" v-html="item.desc"></p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 단지배치도 ===== -->
    <section class="sec sec-layout">
      <div class="sec-inner">
        <p class="sec-eyebrow">UNIT LAYOUT</p>
        <h2 class="section-title">단지배치도</h2>
      </div>
      <img :src="require('@/assets/3.jpg')" alt="단지배치도" class="layout-img" />
    </section>

    <!-- ===== 세대정보 ===== -->
    <section class="sec sec-unit">
      <div class="sec-inner">
        <p class="sec-eyebrow">UNIT PLAN</p>
        <h2 class="section-title">세대정보</h2>

        <div class="unit-tabs">
          <button
            v-for="tab in unitTabs"
            :key="tab.id"
            class="unit-tab"
            :class="{ active: activeUnit === tab.id }"
            @click="activeUnit = tab.id"
          >
            {{ tab.label }}
          </button>
        </div>

        <transition name="fade" mode="out-in">
          <img :src="unitImage" :key="activeUnit" :alt="activeUnit" class="unit-img" />
        </transition>
      </div>
    </section>

    <!-- ===== 커뮤니티 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">COMMUNITY</p>
        <h2 class="section-title">커뮤니티</h2>
      </div>
      <img :src="require('@/assets/4.png')" alt="커뮤니티" class="community-img" />
    </section>

    <!-- ===== 관심고객등록 (하단) ===== -->
    <section class="sec sec-register">
      <div class="sec-inner">
        <h2 class="reg-title">관심고객등록</h2>
        <p class="reg-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

        <div v-if="!isSubmitted">
          <form @submit.prevent="submitForm" class="reg-form">
            <div class="reg-field">
              <label>이름 <span class="req">*</span></label>
              <input type="text" v-model="formData.name" placeholder="이름을 입력해주세요" required />
            </div>
            <div class="reg-field">
              <label>연락처 <span class="req">*</span></label>
              <div class="reg-phone">
                <input type="tel" inputmode="numeric" ref="rp1" v-model="formData.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput('phone1', 3, 'rp2')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="rp2" v-model="formData.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone2', 4, 'rp3')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="rp3" v-model="formData.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone3', 4, null)" />
              </div>
            </div>
            <div class="reg-field">
              <label>희망 방문일시</label>
              <div class="reg-visit">
                <div class="reg-visit-wrap">
                  <svg class="reg-visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  <input type="date" v-model="formData.visitDay" :min="today" />
                </div>
                <div class="reg-visit-wrap">
                  <svg class="reg-visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <select v-model="formData.visitTime">
                    <option value="">시간 선택</option>
                    <option v-for="t in timeSlots" :key="t" :value="t">{{ t }}</option>
                  </select>
                </div>
              </div>
            </div>
            <label class="reg-agree">
              <input type="checkbox" v-model="formData.agree" required />
              <span class="reg-check"></span>
              <span>개인정보 수집 및 이용에 동의합니다.</span>
            </label>
            <button type="submit" class="reg-submit" :disabled="isSubmitting">
              {{ isSubmitting ? '전송 중...' : '상담 신청하기' }}
            </button>
          </form>
        </div>

        <div v-else class="reg-success">
          <div class="reg-success-icon">&#10003;</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'MainView',
  data() {
    return {
      isSubmitting: false,
      isSubmitted: false,
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDay: '',
        visitTime: '',
        agree: false
      },
      timeSlots: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00'],
      activeUnit: '38A',
      unitTabs: [
        { id: '38A', label: '38A' },
        { id: '38B', label: '38B' },
        { id: '38C', label: '38C' },
        { id: '57A', label: '57A' },
        { id: '57B', label: '57B' },
        { id: '59A', label: '59A' },
        { id: '59B', label: '59B' },
        { id: '59C', label: '59C' },
        { id: '59D', label: '59D' },
        { id: '59E', label: '59E' },
        { id: '59F', label: '59F' },
        { id: '78A', label: '78A' },
        { id: '78B', label: '78B' }
      ],
      benefits: [
        { title: '분양가 10% 원천 할인', desc: '계약과 동시에 분양가 10%를 할인받습니다' },
        { title: '잔금 10% 유예', desc: '입주 시 잔금 10%를 유예받습니다' },
        { title: '대출 이자 지원', desc: '입주 후 2년간 대출 이자를 지원받습니다' }
      ],
      seals: [
        { top: '주담대', bottom: '70%' },
        { top: '주택수', bottom: '미포함' },
        { top: '즉시', bottom: '입주' }
      ],
      locationInfos: [
        {
          title: '쾌속교통망',
          desc: '5호선 장한평역, 면목선 경전철(예정)<br/>동부간선도로, 내부순환도로의 광역교통망<br/>청량리역, 용마터널까지 차량 15분대 접근<br/>청량리역 GTX B, C 노선 개통예정'
        },
        {
          title: '생활 인프라',
          desc: '복합쇼핑몰 아트몰링 장안점,<br/>롯데시네마, 롯데백화점 청량리점,<br/>삼육서울병원, 홈플러스 동대문점 등'
        },
        {
          title: '우수한 학군',
          desc: '장평초, 은석초, 동답초, 안평초, 장평중,<br/>동국사대부중·고, 휘경여중·고, 명문학교 인접<br/>장안 사거리 인근 학원 밀집지역'
        },
        {
          title: '쾌적한 자연',
          desc: '중랑천 체육공원, 장평근린공원,<br/>장안근린공원, 답십리공원,<br/>배봉산 둘레길, 용마산 등'
        }
      ],
      freeOptions: [
        { key: 'oven', name: '기능성오븐' },
        { key: 'cooktop', name: '전기쿡탑' },
        { key: 'fridge', name: '콤비냉장고' },
        { key: 'aircon', name: '시스템에어컨' },
        { key: 'clean', name: '빌트인클리어' },
        { key: 'stone', name: '엔지니어드스톤 주방 상판' }
      ],
      premiums: [
        { title: '빠르고 편리한 교통', desc: '<strong>5호선 장한평역</strong>, <strong>동부간선도로</strong> 등<br/>쾌속 교통 인프라' },
        { title: '중심입지의 생활 인프라', desc: '중랑천, 롯데시네마, <strong>초중고교</strong>,<br/>학원가가 <strong>1km 내</strong> 위치' },
        { title: '주거특화 설계', desc: '<strong>팬트리</strong>, <strong>드레스룸</strong>, <strong>빌트인 가전</strong> 등<br/>전세대 주거형 특화설계' },
        { title: '커뮤니티와 휴식공간', desc: '입주민 커뮤니티와 <strong>중앙광장</strong>,<br/><strong>옥상정원</strong>에서 누리는 여유' },
        { title: '힐스테이트 브랜드 프리미엄', desc: '아파트 <strong>브랜드 파워 1위</strong>, <strong>평판 1위</strong><br/>힐스테이트 프리미엄' }
      ]
    }
  },
  computed: {
    unitImage() {
      return require(`@/assets/${this.activeUnit}.png`)
    },
    today() {
      return new Date().toISOString().split('T')[0]
    }
  },
  methods: {
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm() {
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          visitDate: this.formData.visitDay && this.formData.visitTime
            ? `${this.formData.visitDay} ${this.formData.visitTime}`
            : this.formData.visitDay || '',
          source: 'website'
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_19a0a0280bac'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.main-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #fff;
  overflow-x: hidden;
  padding-bottom: 120px;
}

.sec { position: relative; }
.sec-inner { padding: 80px 28px; }

.sec-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #961e1f;
  margin-bottom: 20px;
}

.section-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
}

.placeholder-img {
  width: 100%;
  min-height: 200px;
  background: #f0f0f0;
  border: 2px dashed #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #999;
}

/* ===== 히어로 섹션 ===== */
.sec-hero {
  width: 100%;
  line-height: 0;
}

.hero-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 하이라이트 섹션 ===== */
.sec-highlight {
  background: #fafaf7;
}

.highlight-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 72px 28px;
}

.highlight-sub {
  font-size: 20px;
  font-weight: 500;
  color: #999;
  letter-spacing: 8px;
}

.highlight-sub strong {
  font-size: 34px;
  font-weight: 900;
  color: #1a1a1a;
  letter-spacing: 10px;
}

.highlight-big {
  font-family: 'Paperlogy', sans-serif;
  font-size: 180px;
  font-weight: 900;
  color: #961e1f;
  line-height: 1;
}

.highlight-arrows {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.highlight-arrow {
  width: 36px;
  height: 36px;
  color: #961e1f;
  animation: arrowBounce 1.6s ease-in-out infinite;
}

@keyframes arrowBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(8px); }
}

.highlight-divider {
  width: 40px;
  height: 3px;
  background: #ccc;
  margin: 28px 0;
  border-radius: 2px;
}

.highlight-price-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
}

.highlight-tilde {
  font-family: 'Paperlogy', sans-serif;
  font-size: 64px;
  font-weight: 700;
  color: #999;
  line-height: 1;
}

.highlight-label {
  font-size: 18px;
  font-weight: 500;
  color: #999;
  letter-spacing: 2px;
  margin-bottom: 4px;
}

.highlight-label strong {
  font-size: 30px;
  font-weight: 900;
  color: #961e1f;
  letter-spacing: 3px;
}

.highlight-price {
  font-family: 'Paperlogy', sans-serif;
  font-size: 160px;
  font-weight: 900;
  color: #961e1f;
  line-height: 1;
}

.highlight-unit {
  display: block;
  margin-top: 8px;
  text-align: center;
  font-size: 42px;
  font-weight: 900;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}

.highlight-from {
  font-size: 28px;
  font-weight: 600;
  color: #888;
  margin-top: 8px;
}

/* ===== 파격 혜택 섹션 ===== */
.sec-benefit {
  background: #961e1f;
  text-align: center;
}

.sec-benefit .sec-inner { padding: 60px 28px 60px; }

.benefit-big-text {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 42px;
  font-weight: 900;
  color: #fff;
  line-height: 1.2;
}

.benefit-divider {
  width: 40px;
  height: 3px;
  background: rgba(255,255,255,0.4);
  margin: 28px auto;
  border-radius: 2px;
}

.benefit-sub {
  font-size: 16px;
  color: rgba(255,255,255,0.7);
  margin-bottom: 8px;
}

.benefit-sub strong {
  color: #fff;
  font-weight: 800;
}

.benefit-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 38px;
  font-weight: 900;
  color: #fff;
  margin-bottom: 36px;
}

/* 도장 영역 */
.stamp-area {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 48px;
}

.benefit-tagline {
  margin-top: 40px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
}

.benefit-tagline-text {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 30px;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.5px;
}

.benefit-tagline-text strong {
  font-family: 'Paperlogy', sans-serif;
  font-size: 42px;
  font-weight: 900;
  color: #FFD782;
  padding: 0 2px;
}

.benefit-tagline-mark {
  font-family: 'Paperlogy', sans-serif;
  font-size: 42px;
  font-weight: 900;
  color: #FFD782;
  margin-left: 4px;
}

.benefit-seals {
  margin-top: 28px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.seal {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  border: 3px solid #FFD782;
  background: rgba(255, 215, 130, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #FFD782;
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-weight: 900;
  letter-spacing: -0.5px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.2);
  flex-shrink: 0;
}

.seal-top {
  font-size: 15px;
  opacity: 0.85;
  margin-bottom: 3px;
}

.seal-bottom {
  font-size: 24px;
  line-height: 1;
}

.benefit-video {
  margin-top: 32px;
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  border-radius: 16px;
  overflow: hidden;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.stamp {
  opacity: 1;
}

.stamp-inner {
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255, 215, 130, 0.35);
  border-radius: 8px;
  padding: 32px 24px 28px;
  text-align: left;
  position: relative;
  overflow: hidden;
}

.stamp.stamped .stamp-inner::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, rgba(255,255,255,0.15) 0%, transparent 70%);
  animation: stampFlash 0.5s ease-out;
  pointer-events: none;
}

@keyframes stampFlash {
  0% { opacity: 1; transform: scale(0.5); }
  100% { opacity: 0; transform: scale(2); }
}

.stamp-num {
  position: absolute;
  top: 16px;
  right: 20px;
  font-family: 'Paperlogy', sans-serif;
  font-size: 72px;
  font-weight: 900;
  line-height: 1;
  color: rgba(255, 215, 130, 0.22);
  letter-spacing: -2px;
}

.stamp-label {
  display: inline-block;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 4px;
  color: #FFD782;
  margin-bottom: 10px;
}

.stamp-line {
  width: 28px;
  height: 2px;
  background: #FFD782;
  margin-bottom: 14px;
  border-radius: 2px;
}

.stamp-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #fff;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
}

.stamp-desc {
  font-size: 14px;
  color: rgba(255,255,255,0.7);
  line-height: 1.6;
  font-weight: 500;
}


/* ===== 로드맵 섹션 ===== */
.sec-roadmap {
  background: #fafaf7;
  text-align: center;
}

.roadmap-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #961e1f;
  margin-bottom: 20px;
}

.roadmap-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.6;
  margin-bottom: 48px;
}

.roadmap-timeline {
  position: relative;
  text-align: left;
  padding-left: 40px;
  max-width: 360px;
  margin: 0 auto;
}

.roadmap-line {
  position: absolute;
  left: 15px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #961e1f;
  opacity: 0.25;
}

.roadmap-step {
  position: relative;
  padding-bottom: 32px;
}

.roadmap-step:last-child { padding-bottom: 0; }

.roadmap-dot {
  position: absolute;
  left: -40px;
  top: 0;
  width: 30px;
  height: 30px;
  background: #961e1f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 800;
  color: #fff;
  z-index: 1;
}

.roadmap-step-text {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.6;
  padding-top: 4px;
}

/* ===== 요약 섹션 ===== */
.sec-summary {
  background: #1a1a1a;
  text-align: center;
}

.sec-summary .sec-inner { padding: 72px 28px; }

.summary-hook {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 32px;
}

.summary-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 320px;
  margin: 0 auto 36px;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 600;
  color: rgba(255,255,255,0.85);
  text-align: left;
}

.summary-check {
  color: #961e1f;
  font-size: 18px;
  font-weight: 800;
  flex-shrink: 0;
}

.summary-divider {
  width: 40px;
  height: 2px;
  background: rgba(255,255,255,0.2);
  margin: 0 auto 36px;
  border-radius: 2px;
}

.summary-closing {
  font-size: 20px;
  font-weight: 600;
  color: rgba(255,255,255,0.6);
  line-height: 1.8;
}

.summary-closing strong {
  color: #fff;
  font-weight: 800;
  font-size: 22px;
}

/* ===== 스마트채널 CTA 섹션 ===== */
.sec-cta {
  background: #961e1f;
  text-align: center;
}

.sec-cta .sec-inner { padding: 72px 28px; }

.cta-brand {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 4px;
  color: rgba(255,255,255,0.45);
  margin-bottom: 16px;
}

.cta-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 12px;
}

.cta-desc {
  font-size: 15px;
  color: rgba(255,255,255,0.7);
  line-height: 1.6;
}

.cta-divider {
  width: 40px;
  height: 2px;
  background: rgba(255,255,255,0.3);
  margin: 32px auto;
  border-radius: 2px;
}

.cta-last {
  font-size: 17px;
  color: rgba(255,255,255,0.7);
  line-height: 1.8;
}

.cta-last strong {
  color: #fff;
  font-weight: 800;
  font-size: 19px;
}

/* ===== 무상옵션 패키지 섹션 ===== */
.sec-option { background: #f8f9fa; }
.sec-option .sec-inner { padding: 60px 28px; }

.option-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-top: 32px;
}

.option-item {
  background: #fff;
  border-radius: 16px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.option-icon-wrap {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f0f0;
  border-radius: 12px;
}

.option-icon-wrap svg {
  width: 26px;
  height: 26px;
  color: #961e1f;
}

.option-name {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
  line-height: 1.4;
}

/* ===== 프리미엄 5 섹션 ===== */
.sec-premium { background: #fff; }
.sec-premium .sec-inner { padding: 60px 28px; }

.premium-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;
}

.premium-card {
  background: #f8f9fa;
  border-radius: 16px;
  padding: 24px 20px;
  text-align: left;
}

.premium-head {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.premium-num {
  font-family: var(--font-family4);
  font-style: italic;
  font-weight: 700;
  font-size: 24px;
  color: var(--primary, #961e1f);
  line-height: 1;
}

.premium-card-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  line-height: 1;
}

.premium-card-desc {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.premium-card-desc :deep(strong) {
  color: var(--primary, #961e1f);
  font-weight: 700;
}

/* ===== 입지환경 섹션 ===== */
.sec-location { background: #fff; }
.sec-location .sec-inner { padding: 40px 28px 16px; }

.location-caption-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 28px 20px;
}

.location-caption {
  flex: 1;
  text-align: left;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1.5;
  letter-spacing: -0.8px;
  margin: 0;
}

.location-caption strong {
  color: var(--primary, #961e1f);
  font-weight: 900;
}

.location-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.location-logo-symbol {
  height: 28px;
  width: auto;
  object-fit: contain;
}

.location-logo-text {
  height: 14px;
  width: auto;
  object-fit: contain;
}

.location-img {
  width: 100%;
  height: auto;
  display: block;
}

.location-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  padding: 28px;
}

.location-card {
  background: #f8f9fa;
  border-radius: 14px;
  padding: 18px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.location-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.location-card-num {
  width: 22px;
  height: 22px;
  background: var(--primary, #961e1f);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family4);
  font-style: italic;
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
}

.location-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  letter-spacing: -0.5px;
}

.location-card-desc {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  letter-spacing: -0.3px;
  margin: 0;
}

.sec-layout { background: #fafaf7; }
.sec-layout .sec-inner { padding: 40px 28px 16px; }

.layout-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 세대정보 섹션 ===== */
.sec-unit { background: #fff; }
.sec-unit .sec-inner { padding: 40px 28px 28px; }

.unit-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}

.unit-tab {
  padding: 10px 16px;
  background: #f0f0f0;
  border: none;
  border-radius: 8px;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
}

.unit-tab:hover { background: #e0e0e0; }
.unit-tab.active {
  background: #961e1f;
  color: #fff;
}

.unit-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.sec-community { background: #fafaf7; }
.sec-community .sec-inner { padding: 40px 28px 16px; }

.community-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 관심고객등록 섹션 ===== */
.sec-register { background: #961e1f; }
.sec-register .sec-inner { padding: 72px 28px; }

.reg-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 8px;
}

.reg-desc {
  font-size: 14px;
  color: rgba(255,255,255,0.5);
  text-align: center;
  margin-bottom: 32px;
}

.reg-form { max-width: 400px; margin: 0 auto; }
.reg-field { margin-bottom: 18px; }

.reg-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255,255,255,0.7);
  margin-bottom: 8px;
}

.req { color: #e8a0a0; }

.reg-field input[type="text"],
.reg-field input[type="tel"] {
  width: 100%;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 10px;
  font-family: var(--font-family);
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: border-color 0.2s ease;
}

.reg-field input:focus { border-color: #fff; }
.reg-field input::placeholder { color: #bbb; }

.reg-phone {
  display: flex;
  align-items: center;
  gap: 6px;
}

.reg-phone input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.reg-phone span {
  color: rgba(255,255,255,0.6);
  font-size: 14px;
  flex-shrink: 0;
}

.reg-visit { display: flex; gap: 8px; }

.reg-visit-wrap {
  flex: 1;
  position: relative;
}

.reg-visit-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.reg-visit input,
.reg-visit select {
  width: 100%;
  padding: 14px 16px 14px 40px;
  background: #fff;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 10px;
  font-family: var(--font-family);
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  appearance: none;
  transition: border-color 0.2s ease;
}

.reg-visit input:focus,
.reg-visit select:focus { border-color: #fff; }

.reg-visit select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.reg-agree {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: rgba(255,255,255,0.6);
  margin: 24px 0 20px;
}

.reg-agree input[type="checkbox"] { display: none; }

.reg-check {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.reg-agree input:checked + .reg-check {
  background: #fff;
  border-color: #fff;
}

.reg-agree input:checked + .reg-check::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #961e1f;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.reg-submit {
  width: 100%;
  padding: 16px;
  background: #fff;
  color: #961e1f;
  border: none;
  border-radius: 12px;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.3s ease;
}

.reg-submit:active { background: #e8e8e8; }
.reg-submit:disabled { opacity: 0.6; cursor: not-allowed; }

.reg-success { text-align: center; padding: 40px 0; }

.reg-success-icon {
  width: 56px;
  height: 56px;
  border: 2px solid rgba(255,255,255,0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  margin: 0 auto 16px;
}

.reg-success h3 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.reg-success p {
  font-size: 14px;
  color: rgba(255,255,255,0.5);
}
</style>
